import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const SkeletonWrapper = (WrappedComponent, { component: Skeleton, ammount }) => {
  class WithSkeleton extends Component {
    constructor(props) {
      super(props);

      this.state = { loading: props.shouldFetch && true };
    }

    componentDidMount() {
      if (this.state.loading) {
        WrappedComponent.loadComponent(this.props);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (WrappedComponent.hasLoaded(nextProps)) {
        this.setState({ loading: false });
      }
    }

    render() {
      const { loading } = this.state;

      if (!loading) {
        return <WrappedComponent {...this.props} />;
      }

      if (loading) {
        return _.map(_.range(0, ammount), index => <Skeleton key={index} />);
      }

      return null;
    }
  }

  WithSkeleton.propTypes = {
    shouldFetch: PropTypes.bool,
    skeletonSettings: PropTypes.shape({
      component: PropTypes.node,
      ammount: PropTypes.number,
    }),
  };

  WithSkeleton.defaultProps = {
    shouldFetch: true,
    skeletonSettings: {},
  };

  return WithSkeleton;
};

export default SkeletonWrapper;
